<template>
  <div id="app" ref="app">
    <div @clickMap="clickmap"></div>
    <div class="home-content">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
// import SJheader from "../src/components/common/header.vue"
import SJfooter from "../src/components/common/footer.vue"

export default {
  name: 'app',
  data () {
    return {
      loading: true
    }
  },
  methods: {
    clickmap () {
      this.$router.push("/")
    },
  },
  computed: {
  },
  mounted () {

  },
  components: {
    SJfooter,
  }
}
</script>
<style scoped lang="stylus">
#app
  // min-width 1440px
  .home-content
    position relative
    height 100vh
  .modecontent
    width 100%
    height 100%
    position absolute
    top 0px
    left 0px
</style>
